// src/redux/slices/reservationCompanyReportSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ReservationCompanyProduReport } from "../../Services/Service";
// ✅ THUNK
export const fetchCompanyReport = createAsyncThunk(
    "companyReport/fetchCompanyReport",
    async (params, { rejectWithValue }) => {
        try {
            const response = await ReservationCompanyProduReport(params);
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// ✅ SLICE
const companyReportSlice = createSlice({
    name: "companyReport",
    initialState: {
        loading: false,
        data: [],
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCompanyReport.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchCompanyReport.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCompanyReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default companyReportSlice.reducer;